export default "__VITE_ASSET__abb9f451__"